// extracted by mini-css-extract-plugin
var _1 = "EntityTabEmails-moduleEntityTabEmails__JuouW";
var _2 = "EntityTabEmails-moduleactions__evrW8 PageActions-modulePageActions__lL8Sl";
var _3 = "EntityTabEmails-modulenotice__STu4M";
export { _1 as "EntityTabEmails", _2 as "actions", _3 as "notice" }
